import css from './LoudCrowdButton.styles.scss'

export interface LoudCrowdButtonProps {
  isInHeroSection?: boolean
}

const LoudCrowdButton = ({ isInHeroSection = false }: LoudCrowdButtonProps) => {
  const containerClass = isInHeroSection
    ? css['LoudCrowdButton__container--hero']
    : css.LoudCrowdButton__container

  return (
    <div className={containerClass}>
      <div
        className="lc-signup-container"
        data-lc-button-text="Apply Now"
        data-lc-button-text-color="white"
        data-lc-button-bg-color="#6e3264"
      />
    </div>
  )
}

export default LoudCrowdButton
